var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameCategoryRecentGames(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_531_7954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50001 0.708496C6.95897 0.708496 5.45253 1.16547 4.1712 2.02163C2.88986 2.87779 1.89119 4.09468 1.30145 5.51842C0.71172 6.94216 0.557419 8.50881 0.858062 10.0202C1.1587 11.5317 1.90079 12.92 2.99047 14.0097C4.08016 15.0994 5.4685 15.8415 6.97994 16.1421C8.49137 16.4428 10.058 16.2885 11.4818 15.6987C12.9055 15.109 14.1224 14.1103 14.9785 12.829C15.8347 11.5476 16.2917 10.0412 16.2917 8.50016C16.2892 6.43443 15.4676 4.45401 14.0069 2.99331C12.5462 1.53262 10.5657 0.710933 8.50001 0.708496ZM11.1258 11.126C10.993 11.2587 10.8128 11.3333 10.625 11.3333C10.4372 11.3333 10.2571 11.2587 10.1242 11.126L7.99922 9.00095C7.86637 8.86815 7.79172 8.68801 7.79168 8.50016V4.25016C7.79168 4.0623 7.86631 3.88213 7.99915 3.7493C8.13199 3.61646 8.31215 3.54183 8.50001 3.54183C8.68788 3.54183 8.86804 3.61646 9.00088 3.7493C9.13372 3.88213 9.20835 4.0623 9.20835 4.25016V8.20691L11.1258 10.1244C11.2586 10.2572 11.3332 10.4373 11.3332 10.6252C11.3332 10.813 11.2586 10.9931 11.1258 11.126Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_531_7954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameCategoryRecentGames);
export default __webpack_public_path__ + "static/media/game-category-recent-games.8cd6ebb8ee3285478e9e512bde341a99.svg";
export { ForwardRef as ReactComponent };